import React from 'react';
import { CardProps } from './interface/CardInterface';

import './_Card.scss';

const Card: React.FC<CardProps> = ({ data }) => {
  return (
    <div className="card">
      {data.map((item: any, index: number) => (
        <div key={`item.value--${index}`} className="card__item">
          <span>{item.label}</span>
          <span>{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default Card;
